import { OverlineSublineType } from "@/types/ModuleOptionsType";

export function useSublinesVisibility(sublinesType: OverlineSublineType) {
  return {
    showOverline: sublinesType === "overline",
    showSubline: sublinesType === "subline",
    showDate: sublinesType === "date",
    showCategories: sublinesType === "categories",
    showDateAndCategories: sublinesType === "date-and-categories",
  };
}
